import { NgModule } from '@angular/core';
import { CmsConfig, provideConfig } from '@spartacus/core';
import {
  PRODUCT_CONFIGURATOR_RULEBASED_FEATURE,
  RulebasedConfiguratorRootModule,
} from '@spartacus/product-configurator/rulebased/root';
import {
  PRODUCT_CONFIGURATOR_TEXTFIELD_FEATURE,
  TextfieldConfiguratorRootModule,
} from '@spartacus/product-configurator/textfield/root';

@NgModule({
  declarations: [],
  imports: [RulebasedConfiguratorRootModule, TextfieldConfiguratorRootModule],
  providers: [
    provideConfig(<CmsConfig>{
      featureModules: {
        [PRODUCT_CONFIGURATOR_RULEBASED_FEATURE]: {
          module: () => import('@spartacus/product-configurator/rulebased').then((m) => m.RulebasedConfiguratorModule),
        },
      },
    }),
    provideConfig(<CmsConfig>{
      featureModules: {
        [PRODUCT_CONFIGURATOR_TEXTFIELD_FEATURE]: {
          module: () => import('@spartacus/product-configurator/textfield').then((m) => m.TextfieldConfiguratorModule),
        },
      },
    }),
  ],
})
export class ProductConfiguratorFeatureModule {}
